/**
 * Script de migration — Collection "immobilier"
 * Ajoute les champs manquants à tous les documents existants :
 *   - livreFoncier  : null
 *   - acte          : null
 *   - vsp           : null
 *   - promoteurAccepted : false
 *
 * ⚠️  À exécuter UNE SEULE FOIS depuis ton projet React/Node.
 *
 * Comment l'utiliser :
 *   1. Copie ce fichier dans ton projet (ex: src/scripts/migrateImmobilier.js)
 *   2. Importe et appelle migrateImmobilier() depuis n'importe quel endroit
 *      (ex: un bouton admin caché, ou directement dans main/index temporairement)
 *   3. Vérifie dans Firebase que les champs sont bien ajoutés
 *   4. Supprime l'appel (le script lui-même peut rester sans danger)
 */

import { db } from "@/Firebase"; // ← adapte le chemin si nécessaire
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";

export async function migrateImmobilier() {
  const collectionName = "immobilier"; // ← nom exact de ta collection Firebase

  console.log(`🚀 Début migration collection "${collectionName}"...`);

  try {
    const snapshot = await getDocs(collection(db, collectionName));

    if (snapshot.empty) {
      console.warn("⚠️ Aucun document trouvé dans la collection.");
      return;
    }

    console.log(`📄 ${snapshot.size} document(s) trouvé(s).`);

    let updated = 0;
    let skipped = 0;

    const promises = snapshot.docs.map(async (docSnap) => {
      const data = docSnap.data();
      const updates = {};

      // Ajoute le champ seulement s'il est absent (undefined)
      if (data.livreFoncier === undefined)       updates.livreFoncier = null;
      if (data.acte === undefined)               updates.acte = null;
      if (data.vsp === undefined)                updates.vsp = null;
      if (data.promoteurAccepted === undefined)  updates.promoteurAccepted = false;

      if (Object.keys(updates).length > 0) {
        await updateDoc(doc(db, collectionName, docSnap.id), updates);
        console.log(`  ✅ Mis à jour : ${docSnap.id}`, updates);
        updated++;
      } else {
        console.log(`  ⏭️  Déjà à jour : ${docSnap.id}`);
        skipped++;
      }
    });

    await Promise.all(promises);

    console.log(`\n✅ Migration terminée !`);
    console.log(`   Mis à jour : ${updated} document(s)`);
    console.log(`   Déjà à jour : ${skipped} document(s)`);

  } catch (error) {
    console.error("❌ Erreur lors de la migration :", error);
  }
}